/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */
import { ReactNode } from 'react';
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@radix-ui/react-tooltip';

import { Icons } from '@/components/icons';

interface NodeItemProps {
  icon: ReactNode;
  title?: string;
  nodeName?: string;
  data: any;
  unit?: string;
  onPinToggle: () => void;
  isPinned: boolean;
  hidePin?: boolean;
  tooltipMessage?: string;
}
const NodeItem = ({
  icon,
  title,
  nodeName,
  data,
  unit,
  onPinToggle,
  isPinned,
  hidePin = false,
  tooltipMessage,
}: NodeItemProps) => {
  return (
    <div className="flex flex-col items-end gap-4">
      <div className="group flex w-full items-start justify-between gap-4">
        <div className="flex items-center gap-2">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#0c2d3a]">
            {icon}
          </div>
          <div className="flex flex-col">
            <p className="whitespace-nowrap text-body-sm text-form-input-rest">
              {nodeName}
            </p>
            <p
              className="whitespace-normal break-words text-body-sm text-form-input-disabled"
              style={{ wordWrap: 'break-word' }}
            >
              {title}
            </p>
            <p className="text-body-subtle">
              <span className="pr-[3px] text-h3 text-body-primary">{data}</span>
              <span className="text-body-subtle">{unit}</span>
            </p>
          </div>
        </div>
        {!hidePin &&
          (tooltipMessage != null && tooltipMessage != '' ? (
            // <div className="flex h-full items-start">
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <button
                    className="opacity-0 duration-200 group-hover:opacity-100"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onPinToggle();
                    }}
                  >
                    {isPinned
                      ? Icons.Unpin('size-4 cursor-pointer')
                      : Icons.Pin('size-4 cursor-pointer')}
                  </button>
                </TooltipTrigger>
                <TooltipContent
                  className="w-48 rounded bg-black p-[9px] text-[11px] leading-4 tracking-[2%] text-white"
                  side="left"
                >
                  {tooltipMessage}
                  <TooltipArrow className="fill-black" />
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          ) : (
            // </div>
            <>
              <button
                className="opacity-0 duration-200 group-hover:opacity-100"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onPinToggle();
                }}
              >
                {isPinned
                  ? Icons.Unpin('size-4 cursor-pointer')
                  : Icons.Pin('size-4 cursor-pointer')}
              </button>
            </>
          ))}
      </div>
    </div>
  );
};
export { NodeItem };
